// src/components/MergeInventoryList.jsx
import React from 'react';
import { Card, Typography, Divider } from 'antd';
import MergeInventoryItem from './MergeInventoryItem';

const { Title, Text } = Typography;

const MergeInventoryList = React.memo(({ mergeInventories, mergeMainData }) => {
    if (!mergeInventories || mergeInventories.length === 0) {
        return null; // 인벤토리가 비어있으면 렌더링하지 않음
    }

    // LIFO (Last In, First Out) 이므로 배열의 마지막 요소가 가장 "앞"에 있는 블럭입니다.
    // 시각적으로도 가장 위에 오도록 배열을 뒤집어서 맵핑합니다.
    const displayItems = [...mergeInventories].reverse();

    return (
        <Card
            title={<Title level={5} style={{ margin: 0, textAlign: 'center', color: '#ff7875' }}>보상 블럭</Title>}
            style={{
                width: '140px',
                minHeight: '100px',
                backgroundColor: '#fff',
                borderRadius: '16px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                padding: '5px',
                position: 'absolute', // 화면 우측에 배치
                top: '85px',
                right: '530px',
                zIndex: 9,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center', // 아이템들을 중앙 정렬
            }}
        >
            <Divider style={{ margin: '5px 0' }} />
            <div style={{ maxHeight: '400px', overflowY: 'auto', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {displayItems.map((item, index) => (
                    <MergeInventoryItem
                        key={`inventory-${item.mIndex}-${index}`} // 고유 키
                        item={item}
                        mergeMainData={mergeMainData}
                        isTopItem={index === 0} // 뒤집은 배열에서 첫 번째 아이템이 원본의 마지막 아이템 (맨 앞)
                    />
                ))}
            </div>
        </Card>
    );
});

export default MergeInventoryList;